import {
  sendEmail,
  replyToEmail,
  addActivity,
  addNote,
  markPulse,
  // fetchActivityByEmailMessages,
} from '../../routines';

const initialState = {
  email: {
    loading: false,
    isSuccess: false,
  },
  replyToEmail: {
    loading: false,
    isSuccess: false,
  },
  addActivity: {
    loading: false,
    isSuccess: false,
  },
  addNote: {
    loading: false,
    isSuccess: false,
  },
  addHealthLog: {
    loading: false,
    isSuccess: false,
  },
  // activityData: {
  //   loading: {},
  //   isSuccess: {},
  // },
};

const entityActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case replyToEmail.TRIGGER:
      return {
        ...state,
        replyToEmail: {
          ...state.replyToEmail,
          loading: true,
          isSuccess: false,
        },
      };
    case replyToEmail.SUCCESS:
      return {
        ...state,
        replyToEmail: {
          ...state.replyToEmail,
          loading: false,
          isSuccess: true,
        },
      };
    case replyToEmail.FAILURE:
      return {
        ...state,
        replyToEmail: {
          ...state.replyToEmail,
          loading: false,
          isSuccess: false,
        },
      };
    case sendEmail.TRIGGER:
      return {
        ...state,
        email: {
          ...state.email,
          loading: true,
          isSuccess: false,
        },
      };
    case sendEmail.SUCCESS:
      return {
        ...state,
        email: {
          ...state.email,
          loading: false,
          isSuccess: true,
        },
      };
    case sendEmail.FAILURE:
      return {
        ...state,
        email: {
          ...state.email,
          loading: false,
          isSuccess: false,
        },
      };
    case addActivity.TRIGGER:
      return {
        ...state,
        addActivity: {
          ...state.addActivity,
          loading: true,
          isSuccess: false,
        },
      };

    case addActivity.SUCCESS:
      return {
        ...state,
        addActivity: {
          ...state.addActivity,
          loading: false,
          isSuccess: true,
        },
      };

    case addActivity.FAILURE:
      return {
        ...state,
        addActivity: {
          ...state.addActivity,
          loading: false,
          isSuccess: false,
        },
      };

    case addNote.TRIGGER:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          loading: true,
          isSuccess: false,
        },
      };

    case addNote.SUCCESS:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          loading: false,
          isSuccess: true,
        },
      };

    case addNote.FAILURE:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          loading: false,
          isSuccess: false,
        },
      };

    case markPulse.TRIGGER:
      return {
        ...state,
        addHealthLog: {
          ...state.addHealthLog,
          loading: true,
          isSuccess: false,
        },
      };

    case markPulse.SUCCESS:
      return {
        ...state,
        addHealthLog: {
          ...state.addHealthLog,
          loading: false,
          isSuccess: true,
        },
      };

    case markPulse.FAILURE:
      return {
        ...state,
        addHealthLog: {
          ...state.addHealthLog,
          loading: false,
          isSuccess: false,
        },
      };

    // case fetchActivityByEmailMessages.TRIGGER:
    //   return {
    //     ...state,
    //     activityData: {
    //       loading: true,
    //       isSuccess: false,
    //     },
    //   };
    //
    // case fetchActivityByEmailMessages.SUCCESS:
    //   return {
    //     ...state,
    //     activityData: {
    //       data: action.payload.response.data,
    //       loading: false,
    //       isSuccess: true,
    //     },
    //   };
    //
    // case fetchActivityByEmailMessages.FAILURE:
    //   return {
    //     ...state,
    //     activityData: {
    //       loading: false,
    //       isSuccess: false,
    //       error: action.payload.error,
    //     },
    //   };

    default:
      return state;
  }
};

export default entityActionReducer;
